// extracted by mini-css-extract-plugin
export default {"ldsRing":"styles_ldsRing__-c4k6"};